import React from 'react';

const _PhoneIcon = ({ className = '' }) => (
  <svg
    className={className}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.1618 16.3794L11.1703 16.3844C11.9256 16.8653 12.8223 17.0742 13.7124 16.9766C14.6024 16.8789 15.4326 16.4807 16.0657 15.8475L16.6161 15.2971C16.8619 15.051 17 14.7173 17 14.3695C17 14.0216 16.8619 13.6879 16.6161 13.4418L14.2971 11.1242C14.051 10.8784 13.7173 10.7403 13.3695 10.7403C13.0216 10.7403 12.6879 10.8784 12.4418 11.1242V11.1242C12.3201 11.2461 12.1755 11.3428 12.0164 11.4088C11.8573 11.4747 11.6867 11.5087 11.5145 11.5087C11.3422 11.5087 11.1717 11.4747 11.0126 11.4088C10.8535 11.3428 10.7089 11.2461 10.5872 11.1242L6.87653 7.41288C6.6307 7.16674 6.49262 6.83309 6.49262 6.48522C6.49262 6.13734 6.6307 5.80369 6.87653 5.55756V5.55756C6.9984 5.43584 7.09508 5.29128 7.16105 5.13217C7.22701 4.97305 7.26097 4.8025 7.26097 4.63025C7.26097 4.458 7.22701 4.28745 7.16105 4.12833C7.09508 3.96922 6.9984 3.82467 6.87653 3.70294L4.55826 1.38183C4.31213 1.136 3.97848 0.997925 3.6306 0.997925C3.28273 0.997925 2.94908 1.136 2.70294 1.38183L2.15253 1.93224C1.51951 2.56542 1.12127 3.39548 1.02353 4.28547C0.925791 5.17545 1.1344 6.07216 1.61492 6.82763L1.62061 6.83616C4.16175 10.5979 7.40061 13.8375 11.1618 16.3794V16.3794Z"
      stroke="#47D7AC"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PhoneIcon = React.memo(_PhoneIcon);
